import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import GameProp from '../../propTypes/gameProp';
import { useSanitize } from '../../../../services/customHooks';

function InfoContent(props) {
  const { t, challenge } = props;
  const {
    image,
    name,
    description: challengeDescription,
    rules,
  } = challenge || {};
  const description = useSanitize(challengeDescription);

  return (
    <div className="content">
      <img
        className="challenge-info-header"
        src={image?.url ? image?.url : '/images/game_default.png'}
        alt="challenge"
      />
      <h3 className="name">{name}</h3>
      {description?.length > 0 && (
        <div className="challenge-info-description">
          <div
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>
      )}
      {rules?.length > 0 && (
        <div className="challenge-about-rules">
          <h4>{t('challengeDetails.about.rules')}</h4>
          <p>{rules}</p>
        </div>
      )}
    </div>
  );
}

InfoContent.propTypes = {
  t: PropTypes.func.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
};

export default translate(InfoContent);
